var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsestakeyourtest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 6 0)",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsestakeyourtest);
export default __webpack_public_path__ + "static/media/Ellipsestakeyourtest.206c9f9ab21b5421c404fd0fcf6b866e.svg";
export { ForwardRef as ReactComponent };